import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogFooter,
    AlertDialogTitle,
    AlertDialogDescription,
    AlertDialogCancel,
    AlertDialogAction,
} from "@/components/ui/alert-dialog";

/**
 * In-app confirmation dialog. Replaces native window.confirm() so the message
 * shows only our note (no browser "<domain> says" / "An embedded page at…" chrome).
 */
export default function ConfirmDialog({
    open,
    onOpenChange,
    title = "",
    description,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    onConfirm,
    destructive = false,
    testid = "confirm-dialog",
}) {
    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent data-testid={testid} className="bg-[#141414] border border-[#2a2a2a] rounded-none text-white">
                <AlertDialogHeader>
                    {title && <AlertDialogTitle className="text-white uppercase tracking-wider text-base">{title}</AlertDialogTitle>}
                    <AlertDialogDescription className="text-[#a0a0a0]">{description}</AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel
                        data-testid="confirm-cancel-btn"
                        className="rounded-none bg-transparent border-[#2a2a2a] text-[#a0a0a0] hover:bg-[#1a1a1a] hover:text-white uppercase tracking-wider text-xs">
                        {cancelLabel}
                    </AlertDialogCancel>
                    <AlertDialogAction
                        data-testid="confirm-ok-btn"
                        onClick={onConfirm}
                        className={`rounded-none uppercase tracking-wider text-xs border ${destructive ? "bg-[#ef4444] border-[#ef4444] text-white hover:bg-[#dc2626]" : "bg-[#ff4500] border-[#ff4500] text-white hover:bg-[#e03e00]"}`}>
                        {confirmLabel}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
